import request from "@/http/api";
// V300模块接口
export const v300Api = {
  // 获取智芯云设备列表
  getZXYDeviceList: (projectId) => {
    return request.post("/zxy/solar/solar-device-info/find-navigation-entry", {
      projectId: projectId,
      enabled: true,
    });
  },
  // 获取光伏云设备列表
  getSolarDeviceList: (
    projectId,
    pageNo,
    pageSize = 500,
    isDisabled = true
  ) => {
    return request.get(
      `/v2/solar-motes/pagi?projectId=${projectId}&pageNo=${pageNo}&pageSize=${pageSize}&isDisabled=${isDisabled}`
    );
  },
  // 查询设备状态实时,通过SN号
  findBySn: (sn) => {
    return request.get(`/zxy/solar/solar-device-status/live/sn/${sn}`);
  },
  // 查询设备状态实时
  getStatusLive: (id) => {
    return request.get(`/zxy/solar/solar-device-status/live/${id}`);
  },
  // 查询设备状态（参数）
  getDeviceStatus: (id) => {
    return request.get(`/zxy/solar/solar-device-status/${id}`);
  },
  /** 微电网云 指令控制器 下发单组命令 */
  downEnergy: (data) => {
    return request.post("/zxy/device-command-energy/down-energy", data);
  },
  /** 数据统计 */
  getStatisticsData: (data) => {
    return request.post(
      "/zxy/solar/solar-device-status-record/statistics-data",
      data,
      { headers: { projectId: data.projectId } }
    );
  },
  getHistoryStatisticsData: (data) => {
    return request.post(
      "/zxy/solar/solar-device-statistics/calc-his-statistics",
      data,
      { headers: { projectId: data.projectId } }
    );
  },
  /** 光伏控制器 设备告警记录 分页列表查询 */
  getDeviceAlarmPage: (data, projectId) => {
    return request.post("/zxy/solar/solar-device-alarm-record/page", data, {
      headers: { projectId: projectId },
    });
  },
  /** 光伏控制器 项目策略信息 批量查询 */
  getStrategyQuery: (data) => {
    return request.post("/zxy/solar/project-strategy-info/query", data, {
      headers: { projectId: data.projectId },
    });
  },
  /** 光伏控制器 项目策略信息 根据Sn号批量下发策略，并保存策略 */
  downBatchStrategy: (data, projectId) => {
    return request.post(
      "/zxy/solar/project-strategy-info/down-device-batch-strategy",
      data,
      {
        headers: { projectId: projectId },
      }
    );
  },
  /** 光伏控制器 指令控制器 光伏云 下发单组命令 */
  downSolar: (data, projectId) => {
    return request.post("/zxy/device-command-solar/down-solar", data, {
      headers: { projectId: projectId },
    });
  },
  /** 光伏控制器 项目策略信息 分页列表查询 */
  getStrategyPage: (data, projectId) => {
    return request.post("/zxy/solar/project-strategy-info/page", data, {
      headers: { projectId: projectId },
    });
  },
  /** 光伏控制器 项目策略信息 新增 */
  addStrategy: (data, projectId) => {
    return request.post("/zxy/solar/project-strategy-info", data, {
      headers: { projectId: projectId },
    });
  },
  /** 光伏控制器 项目策略信息 修改 */
  updateStrategy: (data, projectId) => {
    return request.put("/zxy/solar/project-strategy-info", data, {
      headers: { projectId: projectId },
    });
  },
  /** 光伏控制器 项目策略信息 删除 */
  deleteStrategy: (id, projectId = null) => {
    return request.delete(`/zxy/solar/project-strategy-info`, {
      data: id,
      headers: { projectId: projectId },
    });
  },
  /** 设备操作日志 分页列表查询 */
  getDeviceOperationLog: (data) => {
    return request.post("/zxy/manager/device-operation-log/page", data);
  },
};
